import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useAuth, isAdmin } from '@/lib/auth';
import { DiffusionsList } from '@/features/diffusions/diffusions-list';

/**
 * Console unifiée « Diffusions » (admin) — toutes les diffusions réseaux sociaux
 * (défis, replays, clips playlist, articles blog) × tous les réseaux dans un seul
 * tableau : tri par date, filtres, sélection multiple, programmer / publier, lien
 * d'édition. Read-model : VIEW `v_diffusions`.
 */
export function TutorAdminDiffusionsPage() {
  const { profile, user } = useAuth();
  if (!isAdmin(profile, user?.email)) {
    return <p className="p-6 font-sans text-sm">Réservé aux admins.</p>;
  }

  return (
    <div className="mx-auto max-w-4xl p-4 sm:p-6">
      <Link
        to="/tutor/dashboard"
        className="text-ink-500 hover:text-ink-900 mb-4 inline-flex items-center gap-1.5 font-sans text-[13px] transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        Admin
      </Link>

      <div className="mb-6">
        <p className="font-display text-accent-500 text-[11px] font-semibold uppercase tracking-[.14em]">
          Réseaux sociaux
        </p>
        <h1 className="font-display text-ink-900 mt-1 text-2xl font-extrabold tracking-tight">
          Diffusions
        </h1>
        <p className="text-ink-500 mt-1 font-sans text-sm">
          Programme ou publie tes contenus sur YouTube, TikTok, Instagram, Facebook et LinkedIn —
          depuis un seul endroit.
        </p>
      </div>

      <DiffusionsList />
    </div>
  );
}
